import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { commonErrorMessages } from '../../messages';
import { GlobalActions } from '../../model';
import appRoutes from '../../routing/app-routes';
import { ACTION_LOGOUT, logoutThunk, resetUserState } from '../../store';
import { useAppDispatch } from '../redux';
import { useAppNavigation } from '../../utils/navigation.utils';
import { env } from '../../env';

export interface LogoutLogicResult {
  isLoggingOut: boolean;
  onLogout: () => void;
}

export const useLogoutLogic = (
  globalActions: GlobalActions
): LogoutLogicResult => {
  const { appNavigate } = useAppNavigation();
  const dispatch = useAppDispatch();
  const { showToast, closeToast } = globalActions;
  const { formatMessage } = useIntl();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const onLogout = useCallback(() => {
    setIsLoggingOut(true);
    dispatch(logoutThunk())
      .unwrap()
      .then(() => {
        setIsLoggingOut(false);
        dispatch(resetUserState());
        if (env.appModule === 'web') {
          sessionStorage.clear();
          appNavigate(appRoutes.Login, { replace: true });
        } else {
          appNavigate(appRoutes.Login + '?isLogoutMobile=true', {
            replace: true,
          });
        }

        dispatch({
          type: ACTION_LOGOUT,
        });
      })
      .catch(() => {
        setIsLoggingOut(false);
        showToast({
          type: 'error',
          title: formatMessage(commonErrorMessages.errorTitleDefault),
          description: formatMessage(
            commonErrorMessages.errorDescriptionDefault
          ),
          close: closeToast,
        });
      });
  }, [appNavigate, dispatch, showToast, formatMessage, closeToast]);

  return {
    isLoggingOut,
    onLogout,
  };
};
